import { render } from 'react-dom';
import React, { useEffect } from 'react';

import { isSSR } from '../../../helpers/ssr';

import MobileAppBanner from '../../MobileAppBanner/MobileAppBanner';

const FooterAppBanners = () => {
  useEffect(() => {
    if (isSSR) {
      return;
    }

    const NODE = {
      android: document.getElementById('google_play_link--footer'),
      ios: document.getElementById('app_store_link--footer'),
      rustore: document.getElementById('ru_store_link--footer'),
      appgallery: document.getElementById('app_gallery_link--footer'),
    };

    if (NODE.android) {
      render(
        <MobileAppBanner
          siteId="dSite"
          creativeId="bottom"
          deviceType="android"
        />,
        NODE.android,
      );
    }
    if (NODE.rustore) {
      render(
        <MobileAppBanner
          siteId="dSite"
          creativeId="bottom"
          deviceType="rustore"
        />,
        NODE.rustore,
      );
    }
    if (NODE.appgallery) {
      render(
        <MobileAppBanner
          siteId="dSite"
          creativeId="bottom"
          deviceType="appgallery"
        />,
        NODE.appgallery,
      );
    }
    if (NODE.ios) {
      render(
        <MobileAppBanner siteId="dSite" creativeId="bottom" deviceType="ios" />,
        NODE.ios,
      );
    }
  }, []);

  return null;
};

export default FooterAppBanners;
